import { useAtomValue } from 'jotai';
import { useTranslation } from 'react-i18next';
import { unwrappedNavigationKeeperIdAtom } from '@/atoms/navigation';
import { DEFAULT_KEEPER_BASE_ROUTE } from '@/utils/classicLinks';

export const useKeeperNavigationItems = () => {
  const { t } = useTranslation(['navigation']);
  const keeperIqId = useAtomValue(unwrappedNavigationKeeperIdAtom);
  const keeperRoute = `${DEFAULT_KEEPER_BASE_ROUTE}/${keeperIqId}`;

  return [
    {
      id: 'keeper-dashboard',
      label: t('crossPlatform.secondary.dashboard'),
      route: `${keeperRoute}/overview`,
    },
    {
      id: 'keeper-radar',
      label: t('crossPlatform.secondary.radar'),
      route: `${keeperRoute}/radar`,
    },
    {
      id: 'keeper-league-table',
      label: t('crossPlatform.secondary.leagueTable'),
      route: `${keeperRoute}/league-table`,
    },
    {
      id: 'keeper-shots-faced-map',
      label: t('crossPlatform.secondary.shotsFacedMap'),
      route: `${keeperRoute}/shots-faced`,
    },
    {
      id: 'keeper-shots-faced-distribution',
      label: t('crossPlatform.secondary.shotsFacedDistribution'),
      route: `${keeperRoute}/dot-histogram`,
    },
    {
      id: 'keeper-goal-view',
      label: t('crossPlatform.secondary.goalView'),
      route: `${keeperRoute}/goal-view`,
    },
    {
      id: 'keeper-comparison',
      label: t('crossPlatform.secondary.comparison'),
      route: `${keeperRoute}/scatter`,
    },
    {
      id: 'keeper-minutes-played',
      label: t('crossPlatform.secondary.minutesPlayed'),
      route: `${keeperRoute}/minutes-played`,
    },
    {
      id: 'keeper-claimables',
      label: t('crossPlatform.secondary.claimables'),
      route: `${keeperRoute}/claimables`,
    },
    {
      id: 'keeper-similar-players',
      label: t('crossPlatform.secondary.similarPlayers'),
      route: `${keeperRoute}/similar`,
    },
  ];
};
